module.exports = __webpack_public_path__ + "img/signal_wifi_2_bar_lock.00e62b56.svg";